export const DeviceType = {
  Android: 'Android',
  IOS: 'IOS',
};
